import React, { FC } from 'react';
import clsx from 'clsx';

export const Panel: FC<Props> = ({ className, children }: Props) => {
  return (
    <section
      className={clsx(
        'w-full overflow-hidden rounded-md border border-solid border-gray-200 bg-white p-2 sm:p-3 lg:p-4',
        className
      )}
    >
      {children}
    </section>
  );
};

interface Props {
  className?: string;
  children: React.ReactNode;
}
